import {PatientTherapySequenceProvider} from '@/shared/contexts/patient-therapy-sequence-context'
import {PatientTherapySequence} from '@cypro/engine/schema'
import {dialog} from '@cypro/ui/components'
import {Suspense} from 'react'
import {ReversePatientArrivedDialog} from './reverse-patient-arrived-dialog'

export function openReversePatientArrivedDialog(sequence: PatientTherapySequence) {
  return dialog.open('reverse-patient-arrived-dialog', {
    id: 'reverse-patient-arrived-dialog',
    children: (
      <Suspense fallback={null}>
        <PatientTherapySequenceProvider sequenceId={sequence.id}>
          <ReversePatientArrivedDialog sequence={sequence} />
        </PatientTherapySequenceProvider>
      </Suspense>
    ),
  })
}

export function closeReversePatientArrivedDialog() {
  dialog.close('reverse-patient-arrived-dialog', true)
}
